import { Component } from '../../concepts/objects';
import { Point } from '../../platform/geom/Point';
import { Physical } from './entities/Physical';
import { StatePropertyRef } from './ExtendableStore';
import { OverlayPointerTarget } from './overlay/Overlay';

export type PointerTarget = Physical | OverlayPointerTarget;
export const PointerTarget = {

    topComponentNotRoot(input: PointerInfo | PointerTarget[], root: Component) {
        const targets = 'targets' in input ? input.targets : input;
        const t = targets[0] ?? null;
        if (t && t !== root) {
            if (t instanceof Component && t.is(Physical)) {
                return t;
            }
        }
        return null;
    },

    firstComponentNotRoot(input: PointerInfo | PointerTarget[], root: Component) {
        const targets = 'targets' in input ? input.targets : input;
        for (const t of targets) {
            if (t && t !== root) {
                if (t instanceof Component && t.is(Physical)) {
                    return t;
                }
            }
        }
        return null;
    },

};

export interface PointerInfo {
    targets: PointerTarget[];
    pressed?: PointerTarget | null;
    dragging?: boolean;
    edging?: boolean;
    position: Point;
}

export const PointerInfo = StatePropertyRef<PointerInfo>('pointer');
